import React, { useEffect, useState } from 'react';
import DynamicColorSidebar from './DynamicColorSidebar';
import styles from './RightSidebar.module.css';

type Props = {
  onOverviewClick?: () => void;
  onInfoClick?: () => void;
  forceFixedTop?: boolean;
  isProjectMode?: boolean;
  /**
   * Nelle pagine dei link privati non c'e' Overview: i progetti sono pochi e
   * scelti, e per tornare all'elenco basta il nome in alto a sinistra.
   */
  nascondiOverview?: boolean;
};

const RightSidebar: React.FC<Props> = ({ onOverviewClick, onInfoClick, forceFixedTop = false, isProjectMode = false, nascondiOverview = false }) => {
  const [isScrolled, setIsScrolled] = useState<boolean>(false);
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    const handleScroll = (): void => {
      const scrollTop: number = window.pageYOffset;
      // Su mobile, sempre sticky. Su desktop, sticky solo quando scrollato
      const isMobile = window.innerWidth <= 768;
      setIsScrolled(isMobile || scrollTop > 0);
    };

    const handleResize = (): void => {
      const isMobile = window.innerWidth <= 768;
      setIsMobile(isMobile);
      handleScroll();
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);
    
    // Controlla inizialmente
    handleResize();
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const stickyClass = forceFixedTop ? styles.sticky : isScrolled ? styles.sticky : '';
  const projectModeClass = isProjectMode ? styles.projectMode : '';

  return (
    <DynamicColorSidebar className={`${styles.rightSidebar} ${stickyClass} ${projectModeClass}`} disableColorChange={isProjectMode}>
      <nav className={`${styles.heroNav} ${isMobile ? styles.mobileNav : ''}`}>
        {!isMobile && !nascondiOverview && (
          <button onClick={onOverviewClick} className={styles.navLink}>OVERVIEW</button>
        )}
        <button onClick={onInfoClick} className={styles.navLink}>INFO</button>
      </nav>
    </DynamicColorSidebar>
  );
};

export default RightSidebar;
